// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2O_pt","title":"ClientReferral_title__FZ58y","itemText":"ClientReferral_itemText__2egmn"};